export type LifecycleStatus =
	| "pre-launch"
	| "active"
	| "temporarily-unavailable"
	| "discontinued"
	| "inactive";

export const isDiscontinued = (s: LifecycleStatus): boolean =>
	s === "discontinued";

export const isPurchasable = (
	s: LifecycleStatus,
	outOfStock: boolean
): boolean => s === "active" && !outOfStock;

export const isViewable = (s: LifecycleStatus): boolean => s !== "inactive";

export const isPriceVisible = (s: LifecycleStatus): boolean =>
	s === "active" || s === "temporarily-unavailable";
